// src/components/ui/TwoColumnList.js
import React from 'react';
import styles from '../../styles/components/TwoColumnList.module.css';

/**
 * Two-column list component for displaying items in two columns
 * 
 * @param {Object} props - Component props
 * @param {Array} props.items - Array of items to display
 * @param {number} [props.columnCount=2] - Number of columns (default is 2)
 */
export function TwoColumnList({ items, columnCount = 2 }) {
  // Calculate items per column
  const itemsPerColumn = Math.ceil(items.length / columnCount);
  
  // Create arrays for each column
  const columns = Array.from({ length: columnCount }, (_, colIndex) => {
    const startIdx = colIndex * itemsPerColumn;
    return items.slice(startIdx, startIdx + itemsPerColumn);
  });

  return (
    <table className={styles.columnList}>
      <tbody>
        <tr>
          {columns.map((columnItems, idx) => (
            <td key={idx} className={styles.column}>
              {columnItems.map((item, itemIdx) => (
                <div key={itemIdx} className={styles.item}>
                  - {item}
                </div>
              ))}
            </td>
          ))}
        </tr>
      </tbody>
    </table>
  );
}